import logger from '../Helpers/logger';
import dbConnectionManager from './DbConnectionManager';

const GROUPS = 'groups';

class GroupsIdb {
    constructor() {
        if (!GroupsIdb.instance) {
            GroupsIdb.instance = this;
        }
        return GroupsIdb.instance;
    }

    async getConnection() {
        return dbConnectionManager.getConnection();
    }

    async getGroups() {
        try {
            const db = await this.getConnection();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([GROUPS], 'readonly');
                const objectStore = transaction.objectStore(GROUPS);
                const request = objectStore.getAll();

                request.onsuccess = () => {
                    const groups = request.result || [];
                    groups.sort((a, b) => {
                        const timeA = a.timestamp || 0;
                        const timeB = b.timestamp || 0;
                        return timeB - timeA;
                    });
                    resolve(groups);
                };

                request.onerror = event => {
                    logger.error('getGroups error:', event.target.error);
                    reject(event.target.error);
                };
            });
        } catch (error) {
            logger.error('error getGroups catch', error);
            return [];
        }
    }

    async getGroup(groupId) {
        try {
            const db = await this.getConnection();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([GROUPS], 'readonly');
                const objectStore = transaction.objectStore(GROUPS);
                const request = objectStore.get(groupId);

                request.onsuccess = () => {
                    resolve(request.result);
                };

                request.onerror = event => {
                    logger.error('getGroup error:', event.target.error);
                    reject(event.target.error);
                };
            });
        } catch (error) {
            logger.error('error getGroup', error);
        }
    }

    async setGroups(groups) {
        try {
            const db = await this.getConnection();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([GROUPS], 'readwrite');
                const objectStore = transaction.objectStore(GROUPS);

                groups.forEach(group => {
                    if (group.groupId) {
                        objectStore.put(group, group.groupId);
                    }
                });

                transaction.oncomplete = () => {
                    resolve();
                };

                transaction.onerror = event => {
                    logger.error('setGroups transaction error:', event.target.error);
                    reject(event.target.error);
                };
            });
        } catch (error) {
            logger.error('error setGroups', error);
        }
    }

    async setGroup(group) {
        try {
            const key = group.groupId;
            if (!key) return;
            const db = await this.getConnection();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([GROUPS], 'readwrite');
                const objectStore = transaction.objectStore(GROUPS);
                const request = objectStore.put(group, key);

                request.onsuccess = () => {
                    resolve(request.result);
                };

                request.onerror = event => {
                    logger.error('setGroup error:', event.target.error);
                    reject(event.target.error);
                };
            });
        } catch (error) {
            logger.error('error setGroup', error);
        }
    }

    async updateGroup(groupId, updateData) {
        try {
            const db = await this.getConnection();

            // One transaction for read and write: concurrent updates would otherwise
            // merge into a stale copy and drop each other's fields.
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([GROUPS], 'readwrite');
                const objectStore = transaction.objectStore(GROUPS);
                const handleError = event => {
                    logger.error('updateGroup error:', event.target.error);
                    reject(event.target.error);
                };

                const readRequest = objectStore.get(groupId);
                readRequest.onsuccess = () => {
                    const existingGroup = readRequest.result;
                    const dataToSave = existingGroup ? { ...existingGroup, ...updateData } : updateData;
                    const writeRequest = objectStore.put(dataToSave, groupId);
                    writeRequest.onsuccess = () => resolve(writeRequest.result);
                    writeRequest.onerror = handleError;
                };
                readRequest.onerror = handleError;
            });
        } catch (error) {
            logger.error('error updateGroup', error);
        }
    }

    async deleteGroup(groupId) {
        try {
            const db = await this.getConnection();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([GROUPS], 'readwrite');
                const objectStore = transaction.objectStore(GROUPS);
                const request = objectStore.delete(groupId);

                request.onsuccess = () => {
                    resolve(request.result);
                };

                request.onerror = event => {
                    logger.error('deleteGroup error:', event.target.error);
                    reject(event.target.error);
                };
            });
        } catch (error) {
            logger.error('error deleteGroup', error);
        }
    }

    async clearGroups() {
        try {
            const db = await this.getConnection();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([GROUPS], 'readwrite');
                const objectStore = transaction.objectStore(GROUPS);
                const request = objectStore.clear();

                request.onsuccess = () => {
                    resolve(request.result);
                };

                request.onerror = event => {
                    logger.error('clearGroups error:', event.target.error);
                    reject(event.target.error);
                };
            });
        } catch (error) {
            logger.error('error clearGroups', error);
        }
    }
}

const groupsIdb = new GroupsIdb();
export default groupsIdb;

if (typeof window !== 'undefined') {
    window.inspectGroup = async groupId => {
        const gorup = await groupsIdb.getGroup(groupId);
        logger.debug(`[GroupsIdb] Found`, gorup);

        return gorup;
    };
}
